import { render, staticRenderFns } from "./AdminHomeLayout.vue?vue&type=template&id=82247c04&"
import script from "./AdminHomeLayout.vue?vue&type=script&lang=js&"
export * from "./AdminHomeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports